import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DatePipe } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HomeComponent } from './components/home/home.component';
import { SocialMediaPlansComponent } from './components/social-media-plans/social-media-plans.component';
import { BrandingPlansComponent } from './components/branding-plans/branding-plans.component';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ExpertsInComponent } from './components/experts-in/experts-in.component';
import { HeaderComponent } from './components/header/header.component';
import { SlideShowComponent } from './components/slide_show/slide-show.component';
import { FooterComponent } from './components/footer/footer.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { IntersectionObserverModule } from 'ngx-intersection-observer';
import { BusinessNumbersComponent } from './components/business-numbers/business-numbers.component';
import { CommonModule } from '@angular/common';
import { UserDashboardModule } from './user-dashboard/user-dashboard.module';
import { ApplyCouponDialog, PlansComponent } from './user-dashboard/plans/plans.component';
import { PostPreviewComponent } from './components/post-preview/post-preview.component';
import { MatIconModule } from '@angular/material/icon';
import { QuestionaryComponent } from './components/questionary/questionary.component';
import { DeleteBusinessInfoDailog } from './user-dashboard/business-info/business-info.component';
import { DigitalMarketingComponent } from './components/digital-marketing/digital-marketing.component';
import { SeoComponent } from './components/seo/seo.component';
import { GraphicDesignComponent } from './components/graphic-design/graphic-design.component';
import { UIUXComponent } from './components/uiux/uiux.component';
import { WebsiteDevolpmentComponent } from './components/website-devolpment/website-devolpment.component';
import { VideoEditingComponent } from './components/video-editing/video-editing.component';
// import { LoaderComponent } from './helpers/loader/loader.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { MoreToolsComponent } from './components/more-tools/more-tools.component';
import { ToastrModule } from 'ngx-toastr';
import { OurMissionComponent } from './components/our-mission/our-mission.component';
import { OurMotoComponent } from './components/our-moto/our-moto.component';
import { ManagerDashboardModule } from './manager-dashboard/manager-dashboard.module';
import { BackgroundModule } from './helpers/background/background.module';
import { NgxEditorModule } from 'ngx-editor';
import { LoaderModule } from './helpers/loader/loader.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FacebookLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { AdminDashboardModule } from './admin-dashboard/admin-dashboard.module';
import { HomeComponentComponent } from './components/home-component/home-component.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { TaglineComponent } from './components/tagline/tagline.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SocialMediaPlansComponent,
    BrandingPlansComponent,
    DigitalMarketingComponent,
    GraphicDesignComponent,
    SeoComponent,
    UIUXComponent,
    WebsiteDevolpmentComponent,
    VideoEditingComponent,
    AboutusComponent,
    ContactUsComponent,
    LoginComponent,
    RegisterComponent,
    ExpertsInComponent,
    HeaderComponent,
    TaglineComponent,
    SlideShowComponent,
    FooterComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    ExpertsInComponent,
    PlansComponent,
    BusinessNumbersComponent,
    PostPreviewComponent,
    QuestionaryComponent,
    DeleteBusinessInfoDailog,
    // LoaderComponent,
    ForgotPasswordComponent,
    MoreToolsComponent,
    OurMissionComponent,
    OurMotoComponent,
    ApplyCouponDialog,
    HomeComponentComponent,
    HowItWorksComponent,
    TaglineComponent

  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    NgxEditorModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    MaterialModule,
    HttpClientModule,
    MatSnackBarModule,
    ClipboardModule,
    IntersectionObserverModule,
    UserDashboardModule,
    MatIconModule,
    ManagerDashboardModule,
    AdminDashboardModule,
    BackgroundModule,
    LoaderModule,
    MatFormFieldModule,
    MatInputModule,
    SocialLoginModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      timeOut: 1500,
      extendedTimeOut: 700,
      progressBar: true,

    }),
  ],
  exports: [
    DigitalMarketingComponent,
    GraphicDesignComponent,
    SeoComponent,
    UIUXComponent,
    WebsiteDevolpmentComponent,
    VideoEditingComponent,
  ],
  providers: [
    ApplyCouponDialog,
    [
      {
        provide: 'SocialAuthServiceConfig',
        useValue: {
          autoLogin: false,
          providers: [

            {
              id: FacebookLoginProvider.PROVIDER_ID,
              provider: new FacebookLoginProvider('1325895635057818')
            }
          ],
          onError: (err) => {
            console.error(err);
          }
        } as SocialAuthServiceConfig,
      }
    ],
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

